import styled from '@emotion/styled';
import Comps from '@owenscorning/react-library';
import React from 'react';
import { connect } from 'react-redux';

import TextInput from '../../../shared/TextInput/index.jsx';
import { BackArrow } from '../../../shared/svgIcons.jsx';
import { incrementStep, decrementStep, setFormData } from '../../redux/actions';

const { AddressGroup } = Comps.Connect.FormElements;

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;
  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const SplitInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;

  > div {
    width: 48%;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const mapStateToProps = state => ({
  formData: state.formData,
});

const ContractorStep8 = ({
  incrementStep,
  decrementStep,
  formData,
  setFormData,
}) => {
  const validated =
    formData.contractorCompanyName &&
    formData.contractorPhone &&
    formData.contractorPhone.length === 12;

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 8 - how many total squares is the roof"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>How many total squares is the roof?</BackText>
      </BackWrapper>
      <IntroMessage>That's great! Now,</IntroMessage>
      <Header>Tell us a little about your business.</Header>
      <InputWrapper>
        <TextInput
          fieldKey="contractorCompanyName"
          value={formData.contractorCompanyName || ''}
          htmlAttributes={{
            placeholder: 'Company Name',
          }}
        />
      </InputWrapper>
      <SplitInputContainer>
        <TextInput
          fieldKey="contractorFirstName"
          value={formData.contractorFirstName || ''}
          htmlAttributes={{
            placeholder: 'First Name',
          }}
        />
        <TextInput
          fieldKey="contractorLastName"
          value={formData.contractorLastName || ''}
          htmlAttributes={{
            placeholder: 'Last Name',
          }}
        />
      </SplitInputContainer>
      <InputWrapper>
        <AddressGroup
          value={formData.contractorAddress}
          onChange={address => {
            setFormData({ contractorAddress: address });
          }}
          suggestionEndpoint={`${MDMS_URL}/api/v1/smarty/suggestions`}
          showComplaints={false}
          country="US"
          placeholder={{
            street: 'Business Street Address',
          }}
        />
      </InputWrapper>
      <InputWrapper>
        <TextInput
          fieldKey="contractorPhone"
          value={formData.contractorPhone || ''}
          htmlAttributes={{
            placeholder: 'Business Phone',
            pattern: '[0-9 -]*',
            isphoneinput: 'true',
            maxLength: 12,
          }}
        />
      </InputWrapper>
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 8 - how many total squares is the roof"
        onClick={incrementStep}
        disabled={!validated}
      >
        Next
      </NextButton>
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractorStep8);
